import { useQuery } from '@hooks/reactQuery';

import { getApprovalUsersOptions } from '@api/manageApprovalUnit';

import { TSelectOption } from '@interfaces/components/componentTypes';
import { IShortUserInfo } from '@interfaces/user/user';

import { ORGANIZATIONS_USERS_APPROVERS } from '@constants/queryKeys';

export const useQueryApprovalUsersOptions = () => {
	const {
		data: approvalUsersOptions,
		isLoading: isLoadingApprovalUsersOptions,
	} = useQuery<IShortUserInfo[], TSelectOption[]>({
		queryKey: [ORGANIZATIONS_USERS_APPROVERS],
		queryFn: getApprovalUsersOptions,
		select: (users) => {
			return users.map(({ firstName, lastName, id }) => ({
				value: id,
				label: `${firstName} ${lastName}`,
			}));
		},
		refetchOnWindowFocus: false,
	});

	return {
		approvalUsersOptions: approvalUsersOptions || [],
		isLoadingApprovalUsersOptions,
	};
};
